import React, { useState } from "react";
import { Marker, InfoWindow } from "react-google-maps";

const MyMarker = ({ text, tooltip, $hover }) => {
  // const handleClick = () => {
  // };
  const handleClick = () => {
    return (
      <div>
        <span style={{ color: "white" }}>{text}</span>
      </div>
    );
  };

  return (
    // <div className={$hover ? "circle hover" : "circle"} onClick={handleClick}>
    //   <span className="circleText" title={tooltip}>
    //     {text}
    //   </span>
    // </div>
    <div
      style={{ position: "absolute" }}
      className={$hover ? `${handleClick()}` : ``}
    >
      <img
        src="https://kushwaha.in/wp-content/uploads/2016/08/map-marker-icon.png"
        height={20}
        width={20}
      />
    </div>
  );
};

export default MyMarker;
